import React from "react";
import { Field } from "formik";

import { FormCheckbox } from "../../../../../components/ui";
import { EDX_ACCOUNT_TYPE_OPTIONS } from "../constants";

const MicrosCheckBox: React.FC = () => (
  <Field
    name="micros"
    label="Micros"
    placeholder="Plan"
    component={FormCheckbox}
    options={EDX_ACCOUNT_TYPE_OPTIONS}
  />
);

export default MicrosCheckBox;
